import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Alert } from '@interstate/components/Alert';
import { Typography } from '@interstate/components/Typography';

import { getMathStackVariances } from '@makemydeal/dr-dash-store/selectors/mathStackInvariants';
import { getMathStackWarningVisible } from '@makemydeal/dr-dash-store/selectors/offerInfoSelectors';
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';

const MathStackVarianceWarning = () => {
    const variances = useSelector(getMathStackVariances);
    const warningVisible = useSelector(getMathStackWarningVisible);

    const sortedVariances = useMemo(() => [...variances].sort((a, b) => Math.abs(b.variance) - Math.abs(a.variance)), [variances]);

    if (!warningVisible || sortedVariances.length === 0) return null;

    return (
        <Alert type="caution" title="Math-stack variance detected" data-testid="math-stack-variance-warning">
            {sortedVariances.map((result) => (
                <Typography
                    key={result.identity}
                    variant="body-sm"
                    tag="div"
                    data-testid={`math-stack-variance-${result.identity}`}
                >
                    {result.identity}: {formatDollarsAndCents(Math.abs(result.variance))}
                </Typography>
            ))}
        </Alert>
    );
};

export default MathStackVarianceWarning;
